import React from 'react';
import {Route} from "react-router";
import {compArr} from "../selectors";
import {compose} from "redux";
import {connect} from "react-redux";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import {withLoading404} from "../../Boilerplate/deferLoaderHoc";
import {setViewPath} from "../../../actions/view";
import {getSubmittal} from "../../../actions/submittals";
import SubmittalDetail from "./SubmittalDetail";
import SubmittalEdit from "./SubmittalEdit";

class Submittal extends React.PureComponent {
  render() {
    return (
      <div>
        <Route exact path="/projects/:id/submittals/:submittalId" component={SubmittalDetail}/>
        <Route path="/projects/:id/submittals/:submittalId/edit" component={SubmittalEdit}/>
      </div>
    );
  }
}

const SubmittalBreadcrumb = props => PathBreadcrumbItem({ path: `/projects/${props.match.params.id}/submittals/`, resource: props.submittal.resource });

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const submittal = state.view.subview.data[props.match.params.submittalId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'submittals', props.match.params.submittalId];
      if (!compArr(path, itempath) || loading || !submittal) return { loading: true };
      return { submittal, projectId };
    },
    (dispatch, props) => ({
      preload: () => dispatch(setViewPath(['projects', props.match.params.id, 'submittals', props.match.params.submittalId])),
      loader: () => dispatch(getSubmittal(props.match.params.id, props.match.params.submittalId)),
    })),
  withLoading404,
  withBreadcrumbCurried(SubmittalBreadcrumb),
)(Submittal);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/Submittal.js